// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license

//import { registerIcons as registerIcons_ } from "office-ui-fabric-react";
import { registerIcons as registerIcons_ } from "@fluentui/react";


export function registerIcons() {
    registerIcons_({
        fontFace: {
            fontFamily: "FabricMDL2Icons",
        },
        icons: {
            AlertSolid: "\uF331",
            CheckboxComposite: "\uE73A",
            LabelComposite: "\uE932",
            Insights: "\uE3AF",
            MachineLearning: "\uE3B8",
            TagGroup: "\uE3F6",
            ChevronDown: "\uE70D",
            ChevronUp: "\uE70E",
            Edit: "\uE70F",
            Add: "\uE710",
            Settings: "\uE713",
            Link: "\uE71B",
            Search: "\uE721",
            CheckMark: "\uE73E",
            Up: "\uE74A",
            Down: "\uE74B",
            Delete: "\uE74D",
            Cloud: "\uE753",
            ChevronLeft: "\uE76B",
            ChevronRight: "\uE76C",
            Home: "\uE80F",
            View: "\uE890",
            Download: "\uE896",
            Help: "\uE897",
            Rename: "\uE8AC",
            Copy: "\uE8C8",
            Tag: "\uE8EC",
            Info: "\uE946",
            AddTo: "\uECC8",
            OpenFolderHorizontal: "\uED25",
            DocumentManagement: "\uEFFC",
            TextDocument: "\uF029",
            BranchMerge: "\uF295",
            Plug: "\uF300",
            PlugConnected: "\uF302",
            Hide3: "\uF6AC",
            WarningSolid: "\uF736",
            ZoomIn: "\uE8A3",
            ZoomOut: "\uE71F",
            TextField: "\uEDC3",
            Filter: "\uE71C",
            Table: "\uED86",
            MapLayers: "\uE81E",

            BookAnswers: "\uF8A4",
            Cancel: "\uE711",
            Refresh: "\uE72C",
            Documentation: "\uEC17",
            More: "\uE712",
            ReceiptProcessing: "\uE496",
            KeyPhraseExtraction: "\uE395",
            Share: "\uE72D",
            ChromeRestore: "\uE923",
            ChromeMinimize: "\uE921",
            System: "\uE770",
            SquareShape: "\uF1A6",
            Merge: "\uE7D5",
            AddField: "\uE4C7",
            RectangleShape: "\uF1A9",
            Rotate90CounterClockwise: "\uF80E",
            Rotate90Clockwise: "\uF80D",
        },
    });
}
